// @flow

import * as React from 'react';

import classify from 'src/utils/classify';

import css from './one-line.css';

// TODO (kyle): this should probably share more code with `one-line.jsx`
export function MultiLineTextInput({
  className,
  autoFocus,
  ...props
}: {
  className?: string,
  autoFocus?: mixed,
  onChange?: (SyntheticInputEvent<HTMLInputElement>) => mixed,
  onBlur?: (SyntheticEvent<HTMLInputElement>) => mixed,
  onKeyDown?: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  value?: string,
  defaultValue?: string,
  placeholder?: string,
  disabled?: boolean,
  maxLength?: number,
}): React.Element<'textarea'> {
  const ref = React.useRef();
  React.useEffect(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus]);

  return (
    <textarea
      type="text"
      className={classify(css.multiLine, className)}
      ref={ref}
      {...props}
    />
  );
}
export default MultiLineTextInput;
